const Style = {

  base: 'relative block text-sm mb-2 uppercase',
  error: 'text-sg-red -ml-4 z-2',
  required: `after:text-sg-red after:ml-1 after:font-semibold after:content-['*']`

}

export default Style;